import {Spinner} from "react-bootstrap"

const CenterLoader = () => {
    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="d-flex align-items-center">
                <span className="me-2">Please wait...</span>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            </div>
        </div>
    )
}

export default CenterLoader
